import { CompanyStructureEmployee, CompanyStructureForPlanningResponse } from '@/types/service-response'

export class Employee {
  public label: string

  public constructor (
    readonly id: number,
    readonly department: number,
    readonly profitCenter: number,
    readonly planningGroupId: number | null,
    readonly floater: boolean,
    readonly fullName: string,
    readonly floaterDepartments: Array<number>,
    readonly planbar: boolean,
    readonly status: boolean,
    readonly IST: string,
    readonly MGAZ: string,
    readonly note: string,
    readonly position?: number | null
  ) {
    this.label = fullName
  }

  static createFromResponse (responseData: CompanyStructureForPlanningResponse): Array<Employee> {
    let result: Array<Employee> = []

    if (responseData.mitarbeiters) {
      result = responseData.mitarbeiters.map((employee: CompanyStructureEmployee) => {
        return new Employee(
          employee.id,
          employee.abteilung,
          employee.profitCenter,
          employee.planungsgruppeID,
          employee.springer,
          employee.namevollstanding,
          employee.springerAbteilungs,
          employee.planbar,
          employee.status,
          employee.IST,
          employee.MGAZ,
          employee.Notiz,
          employee.position
        )
      })
    }

    result.sort(function (a, b) {
      return a.fullName.localeCompare(b.fullName)
    })

    return result
  }
}
